export const REQUEST_STARTED = 'Request Started';
export const REQUEST_SUCCESS = 'Request Success';
export const REQUEST_FAILURE = 'Request Failure';
